module.exports = __webpack_public_path__ + "static/fire_giant_dreadnought-a51965514b44c8f9bc2973ee05b9467a.jpeg";